import { ReasonToken } from '@bonusly/recipient-entities';

export interface Image {
	filename: string;
	url: string;
}

// Numeric values mirror the backend constants in
// app/services/video_processing/processor.rb (STATUS_FAILED/MISSING/PROCESSING/
// COMPLETED), which is what the blueprint serializes as `status`. If we switch
// to string statuses on the wire, update the backend blueprint at the same time
// and keep this enum and the comparisons in AnnouncementVideo in sync.
export enum VideoStatus {
	Failed = -1,
	Missing = 0,
	Processing = 1,
	Completed = 2,
}

export interface Video {
	video_id: string;
	status: VideoStatus;
	video_thumbnail_url?: string | null;
	video_poster_url?: string | null;
	video_transcript_url?: string | null;
	video_hd_url?: string | null;
	video_sd_url?: string | null;
	video_original_url?: string | null;
}

export interface Announcement {
	company_id: string;
	created_at: string;
	created_by_display_name: string;
	created_by_id: string;
	created_by_profile_pic_url: string;
	created_by_username: string;
	description: string;
	email_notification: boolean;
	full_width_image?: boolean;
	send_slack_message: boolean;
	send_ms_teams_message: boolean;
	end_date: string;
	id: string;
	image?: Image;
	video?: Video | null;
	reason_tokens: ReasonToken[];
	start_date: string;
	title: string;
	claimable_award_id?: string;
}
export interface FormValues {
	claimable_award_id?: string;
	description: string;
	email_notification: boolean;
	end_date: string;
	full_width_image: boolean;
	image?: File[];
	video?: Video | null;
	recipients: string[];
	send_slack_message: boolean;
	send_ms_teams_message: boolean;
	start_date: string;
	title: string;
}

export interface UserAnnouncements {
	posted: Announcement[];
	scheduled: Announcement[];
}

export interface Incentives {
	items: Incentive[];
}

export interface Incentive {
	id: string;
	name: string;
}

export interface IncentiveData {
	id: string;
	auto_approved: boolean;
	award_avatar: string;
	deleted_at: string | null;
	description: string;
	giver_id: string;
	name: string;
	out_of_stock: boolean;
	state: 'active' | 'inactive';
	stock_message: string;
}
